module.exports = __webpack_public_path__ + "static/media/layout_web_KARROT–KK_1.cf9e33fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/dummies/layout_web_KARROT–KK_1.png
// module id = 134
// module chunks = 0